import * as InsurerActionTypes from '../actions/insurers';
import initialState from './initialState';

import { errorResponseHandler } from '../utils/error-utils';

export default (state=initialState.insurers, action) => {

    const { payload, type } = action;

    switch(type){

        case InsurerActionTypes.LIST_OTHER_RATES:
        case InsurerActionTypes.LIST_OTHER_RATES_PENDING:
            return { ...state }

        case InsurerActionTypes.LIST_OTHER_RATES_REJECTED:
            return { ...state, error: true, errorMessage: payload.response.data }

        case InsurerActionTypes.LIST_OTHER_RATES_FULFILLED:
            return { ...state, error: false, otherRates: payload.data }

        case InsurerActionTypes.LIST_INSURERS:
        case InsurerActionTypes.LIST_INSURERS_PENDING:
            return { ...state }

        case InsurerActionTypes.LIST_INSURERS_REJECTED:
            return {...state, ...errorResponseHandler(payload, 'InsurerList') }

        case InsurerActionTypes.LIST_INSURERS_FULFILLED:
            return { ...state, insurers: payload.data }

        
        case InsurerActionTypes.LIST_INSURERS_PREMIUMS:
        case InsurerActionTypes.LIST_INSURERS_PREMIUMS_PENDING:
            return { ...state }

        case InsurerActionTypes.LIST_INSURERS_PREMIUMS_REJECTED:
            return {...state, ...errorResponseHandler(payload, 'InsurerPremiumsList') }

        case InsurerActionTypes.LIST_INSURERS_PREMIUMS_FULFILLED:
            return { ...state, insurers_by_premiums: payload.data }


        case InsurerActionTypes.UPDATE_INSURER:
        case InsurerActionTypes.UPDATE_INSURER_PENDING:
            return { ...state }

        case InsurerActionTypes.UPDATE_INSURER_REJECTED:
            return {...state, ...errorResponseHandler(payload, 'InsurerForm') }

        case InsurerActionTypes.UPDATE_INSURER_FULFILLED:
            return { ...state, insurer_updating: false, successInsurerForm: true, successMessage: 'Insurer updated' }

        default:
            return state
    }
}





// WEBPACK FOOTER //
// ./src/reducers/insurers.js